import type { CategoryMiniEntity } from '@/features/category/domain/entities/CategoryMiniEntity'
import type { ItemTranslationEntity } from './ItemTranslationEntity'
import type { BranchMiniEntity } from '@/features/branch/domain/entities/BranchMiniEntity'
import type { VenderMiniEntity } from '@/features/vender/domain/entities/VenderMiniEntity'
import type { CreateUpdateItemGalleryEntity } from './CreateUpdateItemGalleryEntity'
import type { ItemUnitEntity } from './ItemUnitEntity'
import type { ItemUnitMiniEntity } from '@/features/ItemUnits/domain/entities/ItemUnitsMiniEntity'
import type { ItemOrderSupportType } from '../enums/ItemOrderSupportType'
import type { ItemApprovalStatus } from '@/backend/market'

export class ItemEntity {
  id?: number
  itemId?: number
  notAvailableUntil?: string | null;
  itemTemplateId?: number
  imageUrl?: string | null
  isAvailable?: boolean
  disabled?: boolean
  unitPrice?: number
  maxQuantityPerOrder?: number
  translations?: Array<ItemTranslationEntity> | null
  branch?: BranchMiniEntity
  vender?: VenderMiniEntity
  venderId?: number
  category?: CategoryMiniEntity
  sku?: string
  barcode?: string
  inventoryQuantity?: number
  itemGalleries?: Array<CreateUpdateItemGalleryEntity> | null
  name?: string
  description?: string
  unit?: ItemUnitEntity
  itemUnit?: ItemUnitMiniEntity | null;
  externalBranchDiscountAmount?: number
  orderSupportType?: ItemOrderSupportType
  approvalStatus?: ItemApprovalStatus
}
